import { Component, ElementRef, ViewChildren, QueryList, AfterViewInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-metrics',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section class="py-24 bg-[#050505] border-t border-white/5 relative overflow-hidden">
      <!-- Background Abstract -->
      <div class="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#FF5500]/50 to-transparent opacity-50"></div>

      <div class="container mx-auto px-4 md:px-6 relative z-10">
        <div class="grid grid-cols-2 lg:grid-cols-4 gap-12 text-center">
          
          @for (metric of metrics; track metric.label) {
            <div class="metric-item group relative">
              <div class="flex items-baseline justify-center text-4xl md:text-5xl font-bold mb-3 tracking-tight text-[#FF5500] tabular-nums">
                <span class="text-2xl md:text-3xl mr-1 opacity-80 font-medium" *ngIf="metric.prefix">{{metric.prefix}}</span>
                <span #counter [attr.data-target]="metric.value">0</span>
                <span class="text-2xl md:text-3xl ml-1 opacity-80 font-medium" *ngIf="metric.suffix">{{metric.suffix}}</span>
              </div>
              <div class="h-1 w-10 bg-[#333] mx-auto mb-3 rounded-full group-hover:bg-[#FF5500] transition-colors duration-500"></div>
              <p class="text-sm text-gray-300 font-medium uppercase tracking-wide leading-relaxed max-w-[200px] mx-auto">
                {{metric.label}}
              </p>
            </div>
          }

        </div>
      </div>
    </section>
  `
})
export class MetricsComponent implements AfterViewInit, OnDestroy {
  @ViewChildren('counter') counters!: QueryList<ElementRef>;
  private observer: IntersectionObserver | null = null;

  metrics = [
    { value: 300, prefix: '+', suffix: '', label: 'Empresas usando nossa solução' },
    { value: 35, prefix: '', suffix: '%', label: 'Melhora de produtividade em nossos clientes' },
    { value: 27, prefix: '+', suffix: ' mil', label: 'Colaboradores protegidos pela nossa solução' },
    { value: 97, prefix: '', suffix: '%', label: 'Redução de ações trabalhistas' }
  ];

  ngAfterViewInit() {
    if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const el = entry.target as HTMLElement;
            this.animateValue(el);
            this.observer?.unobserve(el);
          }
        });
      }, { threshold: 0.5 });

      this.counters.forEach(counter => {
        this.observer?.observe(counter.nativeElement);
      });
    }
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }

  animateValue(element: HTMLElement) {
    const target = parseInt(element.getAttribute('data-target') || '0', 10);
    const duration = 2000; // 2 seconds
    const start = 0;
    let startTimestamp: number | null = null;

    const step = (timestamp: number) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      
      // Easing function for smooth animation (easeOutQuart)
      const easeProgress = 1 - Math.pow(1 - progress, 4);
      
      const current = Math.floor(easeProgress * (target - start) + start);
      element.innerText = current.toString();

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        element.innerText = target.toString();
      }
    };

    window.requestAnimationFrame(step);
  }
}